interface IIntercomConfig {
    INTERCOM_APP_ID: string
}

interface IIntercomConfigContext {
    setConfig: (config: IIntercomConfig) => void
    getConfig: () => IIntercomConfig
}

class IntercomConfigContext implements IIntercomConfigContext {
    private config = <IIntercomConfig>{}

    setConfig(config: IIntercomConfig) {
        return (this.config = { ...config })
    }

    getConfig(): IIntercomConfig {
        return { ...this.config }
    }
}

const intercomConfigContext = new IntercomConfigContext()

export type { IIntercomConfig }
export { intercomConfigContext }
